/**
 * IngestKeyboardHelp — Iter 40.2 keyboard shortcut overlay.
 * Triggered by `?` (or shift+/). Closes on Esc / click.
 */
import React from "react";
import { X } from "lucide-react";

const SHORTCUTS = [
  { keys: ["j"], desc: "Next row" },
  { keys: ["k"], desc: "Previous row" },
  { keys: ["e"], desc: "Edit sheet number" },
  { keys: ["t"], desc: "Edit title" },
  { keys: ["d"], desc: "Edit discipline" },
  { keys: ["r"], desc: "Edit revision" },
  { keys: ["Tab"], desc: "Next field in row" },
  { keys: ["Enter"], desc: "Save & advance to next needs-review row" },
  { keys: ["p"], desc: "Publish current row (if ready)" },
  { keys: ["x"], desc: "Discard current row" },
  { keys: ["?"], desc: "Show this overlay" },
  { keys: ["Esc"], desc: "Close overlay" },
];

export default function IngestKeyboardHelp({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-6"
      onClick={onClose}
      data-testid="ingest-keyboard-help"
    >
      <div
        className="max-w-md w-full border border-[var(--fop-border)] rounded-md bg-[var(--fop-surface)] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--fop-steel)]">
            Keyboard shortcuts
          </div>
          <button type="button" onClick={onClose} className="text-[var(--fop-text-3)] hover:text-[var(--fop-text)]" data-testid="ingest-keyboard-help-close">
            <X size={14} />
          </button>
        </div>
        <ul className="space-y-1.5">
          {SHORTCUTS.map((s) => (
            <li key={s.keys.join("+")} className="flex items-center justify-between gap-3 text-xs">
              <span className="text-[var(--fop-text-2)]">{s.desc}</span>
              <span className="inline-flex gap-1">
                {s.keys.map((k) => (
                  <kbd key={k} className="px-1.5 py-0.5 rounded font-mono text-[10px] border border-[var(--fop-border)] bg-[var(--fop-surface-2)] text-[var(--fop-text)]">
                    {k}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
